export default class SetConversationHistoryFilter {
  constructor(context) {
    this.context = context;
  }

  run(filter) {
    this.context.stores.conversationHistoryFilter.set(filter);
  }
}
